import React from "react";
import RolesComponent from "../../components/mosaic/Roles";

const RolesPage: React.FC = () => {
  return <RolesComponent />;
};

export default RolesPage;
